export const THERAPEUTIC_AREAS = [
  {
    id: 'BBU',
    name: 'Biopharmaceuticals Business Unit',
    description:
      'The Biopharmaceuticals Business Unit displays elevated activity in select areas, resulting in a higher risk score.',
  },
  {
    id: 'OBU',
    name: 'Oncology Business Unit',
    description:
      'The Oncology Business Unit shows a stable compliance profile with no significant risk indicators. Current monitoring reflects consistent adherence to established controls and procedures.',
  },
  {
    id: 'RDU',
    name: 'Rare Disease Business Unit',
    description:
      'The Rare Disease Business Unit maintains a low risk posture with no notable alerts. Compliance activities remain within expected parameters across all monitored areas.',
  },
];
